module.exports = __webpack_public_path__ + "img/ungroup.fa4fa21d.svg";